var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscordCircleSmall = function SvgDiscordCircleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 49"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.375,
    r: 24,
    fill: "#5865F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.78 17.537.048-.017h-.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.932 17.519s-2.444-.092-5.081 1.826c0 0-2.637 4.523-2.637 10.098 0 0 1.462 2.503 5.47 2.598 0 0 .585-.766 1.176-1.441-2.251-.673-3.127-2.02-3.127-2.02l.752.383.439.18c2.078.854 4.365 1.795 8.24 1.166l.06-.013c.856-.19 1.713-.38 2.569-.756q.236-.119.5-.242c.462-.22.984-.467 1.541-.818 0 0-.877 1.346-3.222 2.02.483.67 1.162 1.438 1.162 1.438 3.285-.071 4.924-1.764 5.457-2.315.118-.121.182-.187.198-.168 0-5.567-2.653-10.098-2.653-10.098-2.37-1.733-4.586-1.811-5.004-1.813l-.268.264c3.028.863 4.494 2.21 4.494 2.21-4.393-2.163-9.138-2.287-13.484-.578-.683.292-1.075.484-1.075.484s1.463-1.442 4.69-2.211zm1.368 8.27c0 1.064-.833 1.927-1.856 1.927s-1.856-.863-1.856-1.92c0-1.064.833-1.924 1.856-1.924l.006-.004c1.023 0 1.85.863 1.85 1.92m6.642 0c0 1.064-.832 1.927-1.855 1.927s-1.856-.863-1.856-1.92c.003-1.064.837-1.924 1.856-1.924v-.004c1.027 0 1.855.863 1.855 1.92",
    clipRule: "evenodd"
  })));
};
export { SvgDiscordCircleSmall as ReactComponent };